<button mat-fab
        color="primary"
        matTooltip="{{'error_reporting.report_button' | translate}}"
        matTooltipPosition="before"
        (click)="openReportDialog($event)" >
    <mat-icon svgIcon="alert"></mat-icon>
</button>